import React from 'react';
import { Button } from 'antd';
import { cond, equals } from 'ramda';

const TextAttributesButton = ({ attribute, icon, setAttribute, currentAttribute, neutralAttribute }) => {
  const handleChangeTextAttributes = (currentStyle, newStyle, setter) => cond([
    [equals(currentStyle), () => setter(newStyle)],
    [equals(newStyle), () => setter(currentStyle)]
  ]);

  return (
    <Button
      size="normal"
      className={equals(attribute, currentAttribute)
        ? '!text-white !bg-flexi-primary-color border-flexi-primary-color'
        : 'text-flexi-primary-color bg-white border-flexi-primary-color'}
      onClick={() => handleChangeTextAttributes(neutralAttribute, attribute, setAttribute)(currentAttribute)}
      icon={icon}
      shape="round"
    />
  );
};

export default TextAttributesButton;
